import React from 'react';
import { observer } from 'mobx-react-lite';

import { useStores } from 'hooks/useStores';

const DriveType = observer(({ wheelFormula, driveType }) => {
  const {
    dictionariesStore: { wheel_formulas, drive_types },
  } = useStores();

  if (!(wheelFormula || driveType)) return null;

  return (
    <tr>
      <td className="pale">Привод</td>
      <td>
        {[wheel_formulas?.[wheelFormula], drive_types?.[driveType]].filter((el) => el).join(', ')}
      </td>
    </tr>
  );
});

export default DriveType;
